var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main_center",
      staticStyle: {
        padding: "16px",
        "background-color": "rgb(240, 242, 245)",
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: { "padding-top": "16px" },
              attrs: { model: _vm.form, "label-width": "110px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "统计维度：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { "value-key": "value" },
                              on: { change: _vm.typeListChange },
                              model: {
                                value: _vm.form.dimension,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "dimension", $$v)
                                },
                                expression: "form.dimension",
                              },
                            },
                            _vm._l(_vm.dimensionList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.dimension === "3",
                              expression: "form.dimension === '3'",
                            },
                          ],
                          attrs: { label: "时间周期：", props: "dateTime1" },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "month",
                              format: "yyyy-MM",
                              "value-format": "yyyy-MM",
                              placeholder: "选择月",
                            },
                            model: {
                              value: _vm.form.year,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "year", $$v)
                              },
                              expression: "form.year",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.dimension === "1",
                              expression: "form.dimension === '1'",
                            },
                          ],
                          attrs: { label: "时间周期：", props: "dateTime2" },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "year",
                              "value-format": "yyyy",
                              format: "yyyy",
                              placeholder: "选择年",
                            },
                            model: {
                              value: _vm.form.year,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "year", $$v)
                              },
                              expression: "form.year",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.dimension === "2",
                              expression: "form.dimension === '2'",
                            },
                          ],
                          attrs: { label: "时间周期：", props: "dateTime3" },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "year",
                                  format: "yyyy",
                                  "value-format": "yyyy",
                                  placeholder: "选择年",
                                },
                                model: {
                                  value: _vm.form.year,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "year", $$v)
                                  },
                                  expression: "form.year",
                                },
                              }),
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择季度" },
                                  model: {
                                    value: _vm.form.period,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "period", $$v)
                                    },
                                    expression: "form.period",
                                  },
                                },
                                _vm._l(_vm.quarterList, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "所属交易中心：", props: "tradeId" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "", "value-key": "value" },
                              model: {
                                value: _vm.form.tradeId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "tradeId", $$v)
                                },
                                expression: "form.tradeId",
                              },
                            },
                            _vm._l(_vm.tradeOrgIdOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.orgName, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "招标方式：", props: "tradeId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "", "value-key": "value" },
                              model: {
                                value: _vm.form.tenderModeListvalue,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "tenderModeListvalue", $$v)
                                },
                                expression: "form.tenderModeListvalue",
                              },
                            },
                            _vm._l(_vm.tenderModeList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "招标项目类型：", props: "tradeId" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "", "value-key": "value" },
                              model: {
                                value: _vm.form.buyprojectTypeListvalue,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "buyprojectTypeListvalue",
                                    $$v
                                  )
                                },
                                expression: "form.buyprojectTypeListvalue",
                              },
                            },
                            _vm._l(
                              _vm.buyprojectTypeList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.name,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "评定分离：", props: "tradeId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "", "value-key": "value" },
                              model: {
                                value: _vm.form.isassessmentseparationListvalue,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "isassessmentseparationListvalue",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.isassessmentseparationListvalue",
                              },
                            },
                            _vm._l(
                              _vm.isassessmentseparationList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("el-form-item", { attrs: { label: "" } }, [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: { click: _vm.searchBtn },
                              },
                              [_vm._v("统计")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.getreportexporttype("0")
                                  },
                                },
                              },
                              [_vm._v("导出excel")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                padding: "0px 16px 16px",
                "background-color": "#FFF",
              },
            },
            [
              _c("div", { staticClass: "big_box" }, [
                _c("div", { staticClass: "project_box" }, [
                  _c("div", { staticClass: "title center_TT" }, [
                    _vm._v("项目数量统计"),
                  ]),
                  _c("div", { staticClass: "content_box" }, [
                    _c("div", { staticClass: "content_box_30" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue1 borderColor center_TT",
                        },
                        [_vm._v("进场项目（标段）数")]
                      ),
                      _c("div", { staticClass: "flex" }, [
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("数量")]
                          ),
                          _c(
                            "div",
                            { staticClass: "text_num" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getreportexporttype("1")
                                    },
                                  },
                                },
                                [_vm._v("导出")]
                              ),
                              _vm._v(
                                " " + _vm._s(_vm.tableData.countBid) + " "
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("同比增长")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(_vm._s(_vm.tableData.increaseBid)),
                          ]),
                        ]),
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("增长率")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(_vm._s(_vm.tableData.growthrateBid)),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "content_box_30" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue1 borderColor center_TT",
                        },
                        [_vm._v("实际成交数")]
                      ),
                      _c("div", { staticClass: "flex" }, [
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("数量")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(_vm._s(_vm.tableData.countBidOk)),
                          ]),
                        ]),
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("同比增长")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(_vm._s(_vm.tableData.increaseBidOk)),
                          ]),
                        ]),
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("增长率")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(_vm._s(_vm.tableData.growthrateBidOk)),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "content_box_30" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue1 borderColor center_TT",
                        },
                        [_vm._v("废标数")]
                      ),
                      _c("div", { staticClass: "flex" }, [
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("数量")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(_vm._s(_vm.tableData.countAbandone)),
                          ]),
                        ]),
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("同比增长")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(_vm._s(_vm.tableData.increaseAbandone)),
                          ]),
                        ]),
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("增长率")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(_vm._s(_vm.tableData.growthrateAbandone)),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "content_box_10" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue1 borderColor center_TT",
                        },
                        [_vm._v("终止数")]
                      ),
                      _c("div", { staticClass: "text_num_100" }, [
                        _vm._v(" " + _vm._s(_vm.tableData.countStop) + " "),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "content_box_t" }, [
                    _c("div", { staticClass: "content_box_30_center" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue2 borderColor center_TT",
                        },
                        [_vm._v("待定标数")]
                      ),
                      _c("div", { staticClass: "text_num" }, [
                        _vm._v(_vm._s(_vm.tableData.pendbiddingCount)),
                      ]),
                    ]),
                    _c("div", { staticClass: "content_box_30_center" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue2 borderColor center_TT",
                        },
                        [_vm._v("评定分离项目（标段）数")]
                      ),
                      _c("div", { staticClass: "text_num" }, [
                        _vm._v(_vm._s(_vm.tableData.separationCount)),
                      ]),
                    ]),
                    _c("div", { staticClass: "content_box_40_center" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue2 borderColor center_TT",
                        },
                        [_vm._v("远程异地评标项目（标段）数")]
                      ),
                      _c("div", { staticClass: "text_num" }, [
                        _vm._v(_vm._s(_vm.tableData.remoteCount)),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "project_box" }, [
                  _c("div", { staticClass: "title center_TT" }, [
                    _vm._v("交易金额统计"),
                  ]),
                  _c("div", { staticClass: "content_box" }, [
                    _c("div", { staticClass: "content_box_45" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue1 borderColor center_TT",
                        },
                        [_vm._v("交易总额")]
                      ),
                      _c("div", { staticClass: "flex" }, [
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("金额（万元）")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(
                              _vm._s(_vm.tableData.totaltransactionAmount)
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("同比增长（万元）")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(
                              _vm._s(_vm.tableData.totaltransactionIncrease)
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("增长率")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(
                              _vm._s(_vm.tableData.totaltransactionGrowthrate)
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "content_box_45" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue1 borderColor center_TT",
                        },
                        [_vm._v("节约总额")]
                      ),
                      _c("div", { staticClass: "flex" }, [
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("金额（万元）")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(_vm._s(_vm.tableData.totalsavingAmount)),
                          ]),
                        ]),
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("同比增长（万元）")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(_vm._s(_vm.tableData.totalsavingIncrease)),
                          ]),
                        ]),
                        _c("div", { staticClass: "content_box_33_center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content_box_30_title blue2 borderColor center_TT",
                            },
                            [_vm._v("增长率")]
                          ),
                          _c("div", { staticClass: "text_num" }, [
                            _vm._v(_vm._s(_vm.tableData.totalsavingGrowthrate)),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "content_box_10" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue1 borderColor center_TT",
                        },
                        [_vm._v("资金节约率")]
                      ),
                      _c("div", { staticClass: "text_num_100" }, [
                        _vm._v(" " + _vm._s(_vm.tableData.savingRate) + " "),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "project_box" }, [
                  _c("div", { staticClass: "title center_TT" }, [
                    _vm._v("交易主体参与情况统计"),
                  ]),
                  _c("div", { staticClass: "content_box_t" }, [
                    _c("div", { staticClass: "content_box_20_center" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue2 borderColor center_TT",
                        },
                        [_vm._v("中小企业中标率")]
                      ),
                      _c("div", { staticClass: "text_num" }, [
                        _vm._v(_vm._s(_vm.tableData.smentBidderRate)),
                      ]),
                    ]),
                    _c("div", { staticClass: "content_box_20_center" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue2 borderColor center_TT",
                        },
                        [_vm._v("外地企业中标率")]
                      ),
                      _c("div", { staticClass: "text_num" }, [
                        _vm._v(_vm._s(_vm.tableData.nolocalentBidderRate)),
                      ]),
                    ]),
                    _c("div", { staticClass: "content_box_20_center" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue2 borderColor center_TT",
                        },
                        [_vm._v("进场代理业务的代理机构数量")]
                      ),
                      _c(
                        "div",
                        { staticClass: "text_num" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getreportexporttype("2")
                                },
                              },
                            },
                            [_vm._v("导出")]
                          ),
                          _vm._v(" " + _vm._s(_vm.tableData.agencyCount) + " "),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "content_box_20_center" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue2 borderColor center_TT",
                        },
                        [_vm._v("投标企业数量")]
                      ),
                      _c(
                        "div",
                        { staticClass: "text_num" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getreportexporttype("3")
                                },
                              },
                            },
                            [_vm._v("导出")]
                          ),
                          _vm._v(" " + _vm._s(_vm.tableData.applyCount) + " "),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "content_box_20_center" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content_box_30_title blue2 borderColor center_TT",
                        },
                        [_vm._v("中标企业数量")]
                      ),
                      _c(
                        "div",
                        { staticClass: "text_num" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getreportexporttype("4")
                                },
                              },
                            },
                            [_vm._v("导出")]
                          ),
                          _vm._v(" " + _vm._s(_vm.tableData.bidderCount) + " "),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }